import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

import key from 'images/key-blue.svg';

class ViewUpgrade extends Component {
  render() {
    const { text, textBtn } = this.props;
    return (
      <Fragment>
        <div className="view-upgrade">
          <div className="view-upgrade__content">
            <div className="view-upgrade__descr">
              <div className="view-upgrade__icon">
                <img src={key} alt="key" />
              </div>
              <div className="view-upgrade__text">{text}</div>
            </div>
            <div className="view-upgrade__btn">
              <Link to="/" className="btn btn-blue outline">
                {textBtn}
              </Link>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default ViewUpgrade;



// WEBPACK FOOTER //
// ./src/components/ViewUpgrade/ViewUpgrade.js